import { ProjectEnvironment, ProjectIs } from '../../../models/projects.model';

export const environmentSettingsConfig = {
  [ProjectIs.UTMC]: {
    [ProjectEnvironment.DEV]: { matomoSiteId: 9 },
    [ProjectEnvironment.UAT]: { matomoSiteId: 9 },
    [ProjectEnvironment.PROD]: { matomoSiteId: 8 },
  },
  [ProjectIs.STOPCLAIMS]: {
    [ProjectEnvironment.DEV]: { matomoSiteId: 15 },
    [ProjectEnvironment.UAT]: { matomoSiteId: 15 },
    [ProjectEnvironment.PROD]: { matomoSiteId: 14 },
  },
  [ProjectIs.ACME]: {
    [ProjectEnvironment.DEV]: { matomoSiteId: 16 },
    [ProjectEnvironment.UAT]: { matomoSiteId: 16 },
    [ProjectEnvironment.PROD]: { matomoSiteId: 16 },
  },
};
